import React, { Fragment } from 'react';
import Dropdown from 'react-dropdown';
import { 
  Modal, 
  Button, 
  Row, 
  Col, 
  Form, 
  ControlLabel, 
  FormControl, 
  FormGroup, 
  Alert 
} from 'react-bootstrap';

const tradeTypes = [
  { label: 'Buy', value: 'Buy' },
  { label: 'Sell', value: 'Sell' }
];

const AddHistoryModal = ({ 
  showAddHistoryModal, 
  closeModal, 
  historyModalData, 
  modalInputChange, 
  onDropdownChange, 
  newTradeHistory 
}) => {

  if (!historyModalData) return null;

  function renderAlert() {
    if (historyModalData.error) {
      return (
        <Alert bsStyle="danger">
          <strong>Oops!</strong> {historyModalData.error}
        </Alert>
      );
    }           
  }

  function renderPriceInputs() {
    const { tradeType, buyPrice, sellPrice } = historyModalData;

    if (tradeType && tradeType.value === 'Buy') {
      return (
        <FormGroup controlId="buyPrice">
          <ControlLabel>Purchase Price:</ControlLabel>
          <FormControl
            type="number"
            placeholder=""
            value={buyPrice}
            name="buyPrice"
            onChange={modalInputChange} />
        </FormGroup> 
      );
    } else if (tradeType && tradeType.value === 'Sell') {
      return (
        <Fragment>
          <FormGroup controlId="sellPrice">
            <ControlLabel>Sell Price:</ControlLabel>
            <FormControl
              type="number"
              placeholder=""
              value={sellPrice}
              name="sellPrice"
              onChange={modalInputChange} />
          </FormGroup>
          <FormGroup controlId="buyPrice">
            <ControlLabel>Purchase Price:</ControlLabel>
            <FormControl
              type="number"
              placeholder=""
              value={buyPrice}
              name="buyPrice"
              onChange={modalInputChange} />
          </FormGroup>
        </Fragment>
      );
    }
  }

  const { tradeType, symbol, tradeDate } = historyModalData;

  return (
    <Modal show={showAddHistoryModal} onHide={closeModal} className="trade-history-modal">
      <Modal.Header closeButton>
        <Modal.Title>Add to Trade History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col mdOffset={2} md={8}>
            <Form onSubmit={newTradeHistory}>
              <FormGroup controlId="symbol">
                <ControlLabel>Symbol:</ControlLabel>
                <FormControl
                  type="text"
                  placeholder=""
                  value={symbol}
                  name="symbol"
                  onChange={modalInputChange} />
              </FormGroup>
              <FormGroup controlId="sector">
                <ControlLabel>Trade Type:</ControlLabel>
                <Dropdown
                  value={tradeType}
                  options={tradeTypes}
                  onChange={onDropdownChange} />
              </FormGroup> 

              {renderPriceInputs()}

              <FormGroup controlId="date">
                <ControlLabel>Date (mm-dd-yyyy):</ControlLabel>
                <FormControl
                  type="text"
                  placeholder="leave blank for today"
                  value={tradeDate}
                  name="tradeDate"
                  onChange={modalInputChange} />
              </FormGroup>
              
              {renderAlert()}

              <Button
                type="submit"
                className="btn-blue add"
                bsStyle="primary"
              >Add</Button>
            </Form>
          </Col>
        </Row>  
      </Modal.Body>
      <Modal.Footer>
        <Button
          bsStyle="default"
          onClick={closeModal}
        >Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AddHistoryModal;